import axios from '@/user/axios.js'
import { fileDownload } from '@/utils'

const moduleMonitoring = {
  namespaced: true,
  state: {
    keywords: [],
    asins: []
  },
  mutations: {
    SET_ASINS (state, value) {
      state.asins = value
    },
    ADD_ASIN (state, data) {
      state.asins = [
        ...state.asins,
        data
      ]
    },
    UPDATE_ASIN (state, data) {
      const findIndex = state.asins.findIndex(asin => asin.id === data.id)
      state.asins = [
        ...state.asins.slice(0, findIndex),
        data,
        ...state.asins.slice(findIndex + 1)
      ]
    },
    DELETE_ASIN (state, data) {
      const findIndex = state.asins.findIndex(asin => asin.id === data.id)
      state.asins = [
        ...state.asins.slice(0, findIndex),
        ...state.asins.slice(findIndex + 1)
      ]
    },
    SET_KEYWORDS (state, value) {
      state.keywords = value
    },
    ADD_KEYWORD (state, data) {
      state.keywords = [
        ...state.keywords,
        data
      ]
    },
    UPDATE_KEYWORD (state, data) {
      const findIndex = state.keywords.findIndex(keyword => keyword.id === data.id)
      state.keywords = [
        ...state.keywords.slice(0, findIndex),
        data,
        ...state.keywords.slice(findIndex + 1)
      ]
    },
    DELETE_KEYWORD (state, data) {
      const findIndex = state.keywords.findIndex(keyword => keyword.id === data.id)
      state.keywords = [
        ...state.keywords.slice(0, findIndex),
        ...state.keywords.slice(findIndex + 1)
      ]
    }
  },
  actions: {
    listKeywords (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/monitorings/${sellerId}/keywords`)
          context.commit('SET_KEYWORDS', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    addKeyword (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/monitorings/${sellerId}/keywords`, payload)
          context.commit('ADD_KEYWORD', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    updateKeyword (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const { id, ...others } = payload
          const res = await axios.put(`/api/monitorings/${sellerId}/keywords/${id}`, others)
          context.commit('UPDATE_KEYWORD', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    deleteKeyword (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const { id } = payload
          const res = await axios.delete(`/api/monitorings/${sellerId}/keywords/${id}`)
          context.commit('DELETE_KEYWORD', {
            id
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    downloadKeywordsCSV (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/monitorings/${sellerId}/keywords/download/`, { responseType: 'blob' })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listAsins (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/monitorings/${sellerId}/asins`)
          context.commit('SET_ASINS', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    addAsins (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/monitorings/${sellerId}/asins`, {
            monitoringAsins: payload
          })
          for (const data of res.data.data) {
            context.commit('ADD_ASIN', data)
          }
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    updateAsin (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const { id, ...others } = payload
          const res = await axios.put(`/api/monitorings/${sellerId}/asins/${id}`, others)
          context.commit('UPDATE_ASIN', res.data.data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    deleteAsin (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const { id } = payload
          const res = await axios.delete(`/api/monitorings/${sellerId}/asins/${id}`)
          if (res.data.success) {
            context.commit('DELETE_ASIN', {
              id
            })
          }
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    downloadAsinsCSV (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/monitorings/${sellerId}/asins/download/`, { responseType: 'blob' })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleMonitoring
